import { Spin } from 'antd';

function Loader() {
  return <Spin size="large" />;
}

export default Loader;
